import { render, staticRenderFns } from "./Information.vue?vue&type=template&id=0de58c1c"
import script from "./Information.vue?vue&type=script&lang=js"
export * from "./Information.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0de58c1c')) {
      api.createRecord('0de58c1c', component.options)
    } else {
      api.reload('0de58c1c', component.options)
    }
    module.hot.accept("./Information.vue?vue&type=template&id=0de58c1c", function () {
      api.rerender('0de58c1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/management/amendment/Information.vue"
export default component.exports